import * as Styles from '../styles';
import { useState, useEffect } from 'react';
import {BUTTON_VARIANTS} from 'cdk-radial'
import { useTranslation } from "react-i18next";
import { useAnalytics } from '../../../v2/third-party-integration/amplitude';
import { AMPLITUDE_EVENTS } from '../../../constants';

export default function FilterDialog({
  widget,
  filter,
  onSave,
  isOpen,
  onClose,
  filterComponent :FilterComponent
}: any) {
  const { thresholdFields } = widget;
  const {t} = useTranslation();
  const [isSaveDisabled, setSaveDisabled] = useState(false);
  const { trackEvent } = useAnalytics();

  /**
   * Rebuilds settings from current widget props to ensure we always have the latest state
   * This prevents stale snapshots from overwriting widget settings when user has changed them elsewhere
   */
  const buildSettingsFromWidget = () => {
    const existingFields = Array.isArray(widget.fields) ? widget.fields : [];
    const fields = thresholdFields?.map((item: any) => {
      const existingField = existingFields.find(
        (f: any) => f.name === item.name
      );
      return (
        existingField || {
          name: item.name,
          threshold: {
            type: 'absolute',
            conditions: [],
          },
        }
      );
    });

    return {
      id: widget.id,
      dashboardId: widget.dashboardId,
      view: widget.view,
      fields,
    };
  };

  const [updatedFilter, setUpdatedFilter] = useState(() => filter);

  /**
   * Sync settings whenever widget props change to ensure we capture all UI updates
   */
  useEffect(() => {
  }, [widget.id, widget.dashboardId, widget.view, widget.fields, thresholdFields]);

  const resetDialogStateAndClose = () => {
    setUpdatedFilter(filter);
    setSaveDisabled(false);
    onClose();
  };

  const handleSave = () => {
    // Rebuild settings from latest widget state right before saving
    // This ensures we never send stale widget configuration
    const latestSettings = buildSettingsFromWidget();
    
    trackEvent(AMPLITUDE_EVENTS.SAVE_DASHBOARD_SETTINGS, {
      'Item': widget.title,
    });
    onSave(latestSettings, updatedFilter);
  };

  const handleFilterSettingUpdates = (filter:any) =>{
    const updatedFilter = {...filter}
    setUpdatedFilter(updatedFilter);
  }

  const handleValidationError = (isError:boolean) =>{
    setSaveDisabled(isError);
  }

  return (
    <Styles.WidgetFilterDialog
      id="learn-more-dialog"
      title="Filter Settings"
      isOpen={isOpen}
      onClose={resetDialogStateAndClose}
      disableOverlayClicked={false}
      buttonsProps={[
        {
          id: 'dialog-7-action-1',
          onClick: resetDialogStateAndClose,
          text: t('dashboard.settings.cancel'),
          variant: BUTTON_VARIANTS.TEXT,
        },
        {
          id: 'dialog-7-action-2',
          onClick: handleSave,
          isDisabled:isSaveDisabled,
          text: t('dashboard.filter.save'),
          variant: BUTTON_VARIANTS.PRIMARY,
        },
      ]}
    >
      <div style={{
              padding: '10px',
              width: 'auto',
              height:'450px'
            }}>
        { filter && FilterComponent &&
          <FilterComponent filter={filter} widget={widget} onChange={handleFilterSettingUpdates} onValidationError={handleValidationError}>
        </FilterComponent>
      }
      </div>
    </Styles.WidgetFilterDialog>
  );
}
